var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolicySubmittedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C43.9737 120 28.9077 113.759 17.573 102.427C6.24074 91.0947 0 76.0279 0 60C0 43.9721 6.24074 28.9077 17.573 17.573C28.9063 6.24074 43.9721 0 60 0C76.0279 0 91.0947 6.24074 102.427 17.573C113.759 28.9063 120 43.9721 120 60C120 76.0279 113.759 91.0947 102.427 102.427C91.0947 113.759 76.0279 120 60 120ZM60 2.05407C28.0473 2.05407 2.05149 28.0499 2.05149 60.0026C2.05149 91.9553 28.0473 117.951 60 117.951C91.9527 117.951 117.949 91.9553 117.949 60.0026C117.949 28.0499 91.9527 2.05407 60 2.05407Z",
    fill: "url(#paint0_linear_1605_6582)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 17.4367C58.0199 17.4367 56.4102 15.8269 56.4102 13.8471C56.4102 11.8674 58.02 10.2576 59.9997 10.2576C61.9794 10.2576 63.5893 11.8674 63.5893 13.8471C63.5893 15.8269 61.9794 17.4367 59.9997 17.4367ZM59.9997 12.3086C59.1508 12.3086 58.4613 12.9981 58.4613 13.847C58.4613 14.6959 59.1508 15.3855 59.9997 15.3855C60.8486 15.3855 61.5382 14.6959 61.5382 13.847C61.5382 12.9981 60.8486 12.3086 59.9997 12.3086Z",
    fill: "url(#paint1_linear_1605_6582)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 109.744C58.0199 109.744 56.4102 108.134 56.4102 106.154C56.4102 104.175 58.02 102.565 59.9997 102.565C61.9794 102.565 63.5893 104.175 63.5893 106.154C63.5893 108.134 61.9794 109.744 59.9997 109.744ZM59.9997 104.616C59.1508 104.616 58.4613 105.305 58.4613 106.154C58.4613 107.003 59.1508 107.693 59.9997 107.693C60.8486 107.693 61.5382 107.003 61.5382 106.154C61.5382 105.305 60.8486 104.616 59.9997 104.616Z",
    fill: "url(#paint2_linear_1605_6582)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6345 30.9545C90.6547 30.9545 89.0449 29.3447 89.0449 27.365C89.0449 25.3851 90.6548 23.7754 92.6345 23.7754C94.6143 23.7754 96.2241 25.3853 96.2241 27.365C96.2241 29.3439 94.6142 30.9545 92.6345 30.9545ZM92.6345 25.8264C91.7856 25.8264 91.0961 26.516 91.0961 27.3649C91.0961 28.2137 91.7856 28.9033 92.6345 28.9033C93.4834 28.9033 94.1729 28.2137 94.1729 27.3649C94.1729 26.516 93.4834 25.8264 92.6345 25.8264Z",
    fill: "url(#paint3_linear_1605_6582)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.365 96.2241C25.3851 96.2241 23.7754 94.6142 23.7754 92.6345C23.7754 90.6547 25.3853 89.0449 27.365 89.0449C29.3448 89.0449 30.9545 90.6548 30.9545 92.6345C30.9545 94.6143 29.3438 96.2241 27.365 96.2241ZM27.365 91.0959C26.5161 91.0959 25.8265 91.7855 25.8265 92.6344C25.8265 93.4833 26.5161 94.1728 27.365 94.1728C28.2139 94.1728 28.9034 93.4833 28.9034 92.6344C28.9034 91.7864 28.2129 91.0959 27.365 91.0959Z",
    fill: "url(#paint4_linear_1605_6582)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.154 63.5893C104.174 63.5893 102.564 61.9794 102.564 59.9997C102.564 58.02 104.174 56.4102 106.154 56.4102C108.134 56.4102 109.744 58.02 109.744 59.9997C109.744 61.9794 108.134 63.5893 106.154 63.5893ZM106.154 58.4612C105.305 58.4612 104.616 59.1507 104.616 59.9996C104.616 60.8485 105.305 61.5381 106.154 61.5381C107.003 61.5381 107.692 60.8485 107.692 59.9996C107.692 59.1507 107.003 58.4612 106.154 58.4612Z",
    fill: "url(#paint5_linear_1605_6582)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8454 63.5893C11.8656 63.5893 10.2559 61.9794 10.2559 59.9997C10.2559 58.02 11.8657 56.4102 13.8454 56.4102C15.8251 56.4102 17.435 58.02 17.435 59.9997C17.435 61.9794 15.8251 63.5893 13.8454 63.5893ZM13.8454 58.4612C12.9965 58.4612 12.307 59.1507 12.307 59.9996C12.307 60.8485 12.9965 61.5381 13.8454 61.5381C14.6943 61.5381 15.3839 60.8485 15.3839 59.9996C15.3839 59.1507 14.6943 58.4612 13.8454 58.4612Z",
    fill: "url(#paint6_linear_1605_6582)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6345 96.2241C90.6547 96.2241 89.0449 94.6142 89.0449 92.6345C89.0449 90.6547 90.6548 89.0449 92.6345 89.0449C94.6143 89.0449 96.2241 90.6548 96.2241 92.6345C96.2241 94.6143 94.6142 96.2241 92.6345 96.2241ZM92.6345 91.0959C91.7856 91.0959 91.0961 91.7855 91.0961 92.6344C91.0961 93.4833 91.7856 94.1728 92.6345 94.1728C93.4834 94.1728 94.1729 93.4833 94.1729 92.6344C94.1729 91.7864 93.4834 91.0959 92.6345 91.0959Z",
    fill: "url(#paint7_linear_1605_6582)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.365 30.9545C25.3851 30.9545 23.7754 29.3447 23.7754 27.365C23.7754 25.3851 25.3853 23.7754 27.365 23.7754C29.3448 23.7754 30.9545 25.3853 30.9545 27.365C30.9545 29.3439 29.3438 30.9545 27.365 30.9545ZM27.365 25.8264C26.5161 25.8264 25.8265 26.516 25.8265 27.3649C25.8265 28.2137 26.5161 28.9033 27.365 28.9033C28.2139 28.9033 28.9034 28.2137 28.9034 27.3649C28.9034 26.516 28.2129 25.8264 27.365 25.8264Z",
    fill: "url(#paint8_linear_1605_6582)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0007 94.3581C51.8095 94.3581 43.8764 91.4277 37.6641 86.1055C31.5194 80.8428 27.4141 73.5717 26.1046 65.6314C26.0432 65.2605 26.1898 64.886 26.4865 64.6543C26.7831 64.4235 27.1824 64.3731 27.5267 64.5233C28.9681 65.1534 30.4205 66.1268 31.9579 67.1569C34.9028 69.1303 37.9487 71.1706 41.3461 71.1706C41.836 71.1706 42.3287 71.1257 42.8113 71.0396C44.9367 70.6577 46.0576 69.6056 47.2443 68.4921C48.595 67.2256 50.1262 65.7889 53.0556 65.7237C56.3221 65.6504 58.4859 67.2914 60.396 68.7338C61.9528 69.9096 63.2971 70.9242 65.0021 70.9242C65.242 70.9242 65.4883 70.9041 65.7374 70.8647C67.4563 70.5918 68.4589 69.4993 69.5223 68.3427C70.7686 66.9865 72.1807 65.4499 74.7613 65.3821C76.9435 65.3253 78.361 66.3436 79.6037 67.2383C80.5478 67.9178 81.3619 68.5048 82.3838 68.5048C82.5312 68.5048 82.6851 68.4929 82.8407 68.4691C84.2134 68.2612 84.9844 67.2621 85.8791 66.1027C86.7857 64.9278 87.8141 63.5965 89.5998 63.1834C90.7902 62.9096 92.0906 63.1101 93.4549 63.7786C93.8533 63.9746 94.0804 64.4041 94.0181 64.8427C92.8707 72.9617 88.8241 80.4231 82.6244 85.8525C76.3644 91.3395 68.3296 94.3578 60.0001 94.3578L60.0007 94.3581ZM28.5427 67.3847C31.9217 81.9476 44.8291 92.3068 60.0007 92.3068C75.7367 92.3068 89.2973 80.7675 91.8666 65.3381C91.2045 65.111 90.6066 65.0597 90.0599 65.1861C88.9885 65.4333 88.2998 66.3253 87.5013 67.36C86.4849 68.6778 85.3319 70.1713 83.1452 70.5002C82.8887 70.5387 82.6333 70.5588 82.3833 70.5588C80.7001 70.5588 79.4803 69.6797 78.4034 68.905C77.3228 68.1275 76.3063 67.3849 74.8128 67.4352C73.1013 67.4801 72.1884 68.4746 71.0317 69.7328C69.8367 71.0332 68.4823 72.5066 66.0583 72.8922C65.703 72.949 65.3477 72.9774 65.0007 72.9774C62.6069 72.9774 60.8541 71.6533 59.1582 70.3722C57.3515 69.0077 55.6509 67.7166 53.0996 67.7761C50.9559 67.8237 49.9367 68.7789 48.6474 69.9895C47.358 71.2001 45.8966 72.5701 43.173 73.06C42.5713 73.1681 41.9569 73.223 41.3451 73.223C37.3242 73.223 33.8664 70.9062 30.816 68.8622C30.034 68.3374 29.2739 67.8283 28.5422 67.3842L28.5427 67.3847Z",
    fill: "url(#paint9_linear_1605_6582)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3465 73.2244C37.3256 73.2244 33.8678 70.9076 30.8174 68.8636C29.3586 67.8856 27.9803 66.9634 26.7067 66.4058C26.388 66.2666 26.1618 65.9763 26.105 65.6329C25.7983 63.774 25.6426 61.8792 25.6426 60.0012C25.6426 41.0556 41.0553 25.6433 60.0005 25.6433C78.9456 25.6433 94.3584 41.0561 94.3584 60.0012C94.3584 61.6111 94.243 63.2429 94.0159 64.8502C93.9702 65.1752 93.7705 65.4591 93.4802 65.613C93.1899 65.7677 92.8438 65.7723 92.548 65.6276C91.6148 65.1698 90.787 65.0223 90.0581 65.189C88.9867 65.4362 88.2981 66.3291 87.4996 67.3629C86.4831 68.6807 85.3302 70.1742 83.1434 70.5031C82.887 70.5407 82.6306 70.5617 82.3815 70.5617C80.6984 70.5617 79.4786 69.6826 78.4025 68.9079C77.3229 68.1304 76.3028 67.3887 74.812 67.4381C73.1005 67.483 72.1876 68.4775 71.0309 69.7357C69.8359 71.0361 68.4815 72.5095 66.0575 72.8951C65.7022 72.9519 65.3469 72.9803 64.9998 72.9803C62.607 72.9803 60.8533 71.6561 59.1574 70.376C57.3507 69.0116 55.6473 67.7204 53.0979 67.78C50.9541 67.8276 49.935 68.7827 48.6456 69.9933C47.3562 71.203 45.8948 72.5739 43.1712 73.0638C42.5714 73.1701 41.956 73.225 41.3452 73.225L41.3465 73.2244ZM28.0455 64.7676C29.3175 65.3912 30.605 66.2529 31.9584 67.1595C34.9033 69.132 37.9492 71.1732 41.3465 71.1732C41.8364 71.1732 42.3291 71.1292 42.8117 71.0422C44.9371 70.6603 46.0581 69.6091 47.2448 68.4947C48.5955 67.2282 50.1266 65.7915 53.056 65.7263C56.3235 65.6567 58.4873 67.294 60.3965 68.7364C61.9532 69.9122 63.2975 70.9259 65.0025 70.9259C65.2424 70.9259 65.4888 70.9067 65.7379 70.8673C67.4567 70.5944 68.4594 69.5019 69.5227 68.3453C70.769 66.9891 72.1811 65.4534 74.7617 65.3847C76.9467 65.3307 78.3614 66.3462 79.6041 67.2409C80.5482 67.9194 81.3623 68.5074 82.3842 68.5074C82.5316 68.5074 82.6855 68.4954 82.8402 68.4716C84.2129 68.2647 84.984 67.2647 85.8787 66.1062C86.7853 64.9304 87.8136 63.599 89.5993 63.1869C90.4024 63.0019 91.2531 63.0321 92.1424 63.2776C92.2523 62.1851 92.3081 61.088 92.3081 60.0002C92.3081 42.1855 77.8157 27.6936 60.0015 27.6936C42.1872 27.6936 27.6948 42.186 27.6948 60.0002C27.6948 61.5881 27.8129 63.1896 28.0464 64.7676L28.0455 64.7676Z",
    fill: "url(#paint10_linear_1605_6582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_6582",
    x1: 95.8974,
    y1: 35.4286,
    x2: 5.03169,
    y2: 100.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1605_6582",
    x1: 62.1473,
    y1: 12.3771,
    x2: 56.7112,
    y2: 16.2699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1605_6582",
    x1: 62.1473,
    y1: 104.684,
    x2: 56.7112,
    y2: 108.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1605_6582",
    x1: 94.7821,
    y1: 25.895,
    x2: 89.3459,
    y2: 29.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1605_6582",
    x1: 29.5126,
    y1: 91.1645,
    x2: 24.0764,
    y2: 95.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1605_6582",
    x1: 108.302,
    y1: 58.5297,
    x2: 102.865,
    y2: 62.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1605_6582",
    x1: 15.993,
    y1: 58.5297,
    x2: 10.5569,
    y2: 62.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1605_6582",
    x1: 94.7821,
    y1: 91.1645,
    x2: 89.3459,
    y2: 95.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1605_6582",
    x1: 29.5126,
    y1: 25.895,
    x2: 24.0764,
    y2: 29.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1605_6582",
    x1: 80.3828,
    y1: 72.3037,
    x2: 57.6064,
    y2: 107.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1605_6582",
    x1: 80.5565,
    y1: 39.6912,
    x2: 42.5205,
    y2: 79.0258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0000",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565A",
    stopOpacity: 0.83
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicySubmittedIcon);
export default __webpack_public_path__ + "static/media/policy-submitted-icon.6dcb41c01d9600a6cd169d617fec94ab.svg";
export { ForwardRef as ReactComponent };